// removed by extract-text-webpack-plugin
module.exports = {"header":"tQZV0-tgvIS9Vap9_l82C","scale-in":"_2zupuQHXhGlX9hkKFL6ct0","page-content":"W8bdZlZe-wAzdwgD4EQlW","image":"_3Z5fNrOPvB5QetdcE4dvbB","text":"_2ZiLAL3wLzh_fKHOEuJ9wv","intro":"g-S3m1CYpi39llbKtq6EU","slide-up":"_3XMnqDzBShqcxjMDY7_2hL","heading":"_1QrGpY7a78C19cLrDGXjFF","logo":"NI7b8IdIC576WwWxUJQw6","linksList":"_Cpxg-HAFD4ISVN2fBOCf","linksItem":"_3QSYwhha41MRVq9j9uGjYl","curious":"bl-URf-cR0c2UHl7bwPXA","hasCurious":"_3dqnBQmNRqXrVggEKkUSnB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HeaderImageBlock/HeaderImageBlock.module.scss
// module id = 775
// module chunks = 0